import { Input, Select, DatePicker, InputNumber } from "antd";
const { Option } = Select;

export const useFormFields = () => {
  const renderField = (field) => {
    switch (field.type) {
      case "input":
        return <Input />;
      case "select":
        return (
          <Select placeholder={`Select ${field.label}`}>
            {field.options.map((option, index) => (
              <Option key={option} value={field?.values[index]}>
                {option}
              </Option>
            ))}
          </Select>
        );
      case "datepicker":
        return <DatePicker style={{ width: "100%" }} />;
      case "number":
        return <InputNumber style={{ width: "100%" }} />;
      default:
        return <Input />;
    }
  };

  return { renderField };
};
